import type { AxiosError } from 'axios'
import { filter, mergeMap, of } from 'rxjs'
import { catchError, withLatestFrom } from 'rxjs/operators'
import { errorMessage, successMessage } from '../../../../Model/Message/IMessage.js'
import type { Epic } from '../../../index.js'
import { addMessage } from '../../../Slice/Application/ApplicationSlice.js'
import { orderSlice } from '../../../Slice/Order/OrderSlice.js'

export const RerunPreprocessingEpic: Epic = (action$, state$, { OrderRepository, [orderSlice.name]: order }) =>
  action$.pipe(
    filter(order.rerunPreprocessingRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      OrderRepository.resetOrderPreprocessing(action.payload, state.authentication.user).pipe(
        mergeMap((response) =>
          of(
            order.rerunPreprocessingSuccess(response),
            addMessage(successMessage('Preprocessing results discarded. Submit the order to the pipeline to preprocess it again.'))
          )
        ),
        catchError((error: AxiosError) =>
          of(order.rerunPreprocessingFailure({ error }), addMessage(errorMessage('Could not reset the order: ' + error?.message)))
        )
      )
    )
  )
